export default "__VITE_ASSET__BfT6z3ZB__"